import type { TControlledFormComponentProps } from '@chocolate-soup-inc/cs-frontend-components';
import { TCreateUserMutationInput } from '../../generated/graphql';

export const getUserFormFields = () => {
  const formFields: TControlledFormComponentProps<TCreateUserMutationInput>[] = [
    {
      name: 'name',
      label: 'Name',
      type: 'textField'
    },
    {
      name: 'email',
      label: 'Email',
      type: 'textField'
    },
    {
      name: 'title',
      label: 'Title',
      type: 'textField'
    },
    {
      name: 'type',
      label: 'User Type',
      type: 'select',
      inputOptions: {
        options: [
          {
            label: 'Administrator',
            value: 'admin'
          },
          {
            label: 'Team Leader',
            value: 'teamLeader'
          }
        ]
      }
    }
  ];

  return formFields;
};
